


















































// require('./lib/ui/root.js');

import ripple from "./ripple.vue"
import tooltip from "./tooltip.vue"
import iconButton from "./iconButtons.vue"
import gbutton from "./button.vue"
import chatBubble from "./chatBubble.vue"
import multiLineEdit from "./multiLineEdit.vue"

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { setInterval, clearInterval, setTimeout, clearTimeout } from "timers";

import {HTTPPostAPI} from "../lib/httpapi"
import { frontendClient } from "../lib/client";

interface MessageStruct {
    userID: string,
    firstName: string,
    lastName: string,
    fullName: string,
    date: number,
    text: string,
    image?: string, // image URL
    seen: boolean,
    messageID: string,
}

@Component({
    components : {
        ripple,
        gbutton,
        tooltip,
        chatBubble,
        iconButton,
        multiLineEdit
    },
})
export default class Chat extends Vue{

    @Prop({}) connectToUser: HTTPPostAPI["messages/listusers"]["result"]["users"][0];
    // the ID of the user the chat is connected to
    // only 1 for now plz

    get myID() {
        return frontendClient.userData.userID;
    }
    // myID should be obtained later through request
    // ?frontendClient.userData should include ID

    get connectedToName() {
        return this.connectToUser.fullName;
    }

    // this should be obtained later through request

    // currently, this is filled here
    // the userID should match the "connectedToID" and the current user (myID)
    chatResults: {
        items: MessageStruct[]
    } = {
        items: []
    }

    curImageFile?: string = null;
    addPhoto(){
        let fileSelector = this.$refs.imageSelector as HTMLInputElement;
        fileSelector.click();

        fileSelector.onchange = (ev) => {
            let file = fileSelector.files[0];

            if(file) {
                (this.$refs.imagePreviewRegion as HTMLDivElement).innerHTML = "";

                let fileReader = new FileReader();
                fileReader.readAsBinaryString(file);

                fileReader.onload = async (e) => {
                    this.curImageFile = fileReader.result.toString();
                    let img = document.createElement('img');
                    img.src='data:image/jpeg;base64,' + btoa(((e.target as FileReader).result as string));
                    img.className="image";
                    img.style.maxHeight="100px";
                    (this.$refs.imagePreviewRegion as HTMLDivElement).appendChild(img);
                    (this.$refs.imagePreviewWrapper as HTMLDivElement).style.display = "block";
                }
            }
        }
    }

    removeImage(){
        this.curImageFile = null;
        (this.$refs.imagePreviewRegion as HTMLDivElement).innerHTML = "";
        (this.$refs.imagePreviewWrapper as HTMLDivElement).style.display = "";
    }

    @Watch("connectToUser")
    async updateBaseHistory(_,lastUser) {
        if(lastUser) {
            if(lastUser.userID === this.connectToUser.userID) {return;}
        }

        let history = await frontendClient.postEx("messages/history",{
            userID: this.connectToUser.userID,
        })

        this.chatResults.items = [];

        for(let entry of history.messages) {
            this.chatResults.items.push({
                userID: entry.fromUserID,
                fullName: (entry.fromUserID == this.myID) ? "Me" : this.connectedToName,
                firstName: (entry.fromUserID == this.myID) ? "Me" : this.connectToUser.firstName,
                lastName: (entry.fromUserID == this.myID) ? "" : this.connectToUser.lastName,
                text: entry.body,
                date: entry.timestamp,
                image: entry.image ? entry.image : null,
                seen: entry.hasBeenRead,
                messageID: entry.messageID,
            })
        }

        setTimeout(() => {
            // scroll to bottom
            let element = this.$refs.contentBody as HTMLElement;
            element.scrollTop = element.scrollHeight - element.clientHeight;
        },50);
    }

    hasHistory = true;
    isGettingHistory = false;
    onchatscroll() {
        if(!this.hasHistory) {return;}
        if(this.isGettingHistory) {return;}

        let scrollingElement = this.$refs.contentBody as HTMLDivElement;
        let shouldGetHistory = scrollingElement.scrollTop <= 10;

        if(shouldGetHistory) {
            this.isGettingHistory = true;
            this.updatePastHistory().finally(() => {
                this.isGettingHistory = false;
            });
        }
    }

    async updatePastHistory() {
        let oldestMsg = this.chatResults.items[0];
        if(!oldestMsg) {return;}
        if(!oldestMsg.messageID) {return;}

        let history = await frontendClient.postEx("messages/history",{
            userID: this.connectToUser.userID,
            beforeMessageID: oldestMsg.messageID,
        })

        if(history.messages.length === 0) {
            this.hasHistory = false;
            return;
        }

        for(let entry of history.messages) {
            this.chatResults.items.splice(0,0,{
                userID: entry.fromUserID,
                fullName: (entry.fromUserID == this.myID) ? "Me" : this.connectedToName,
                firstName: (entry.fromUserID == this.myID) ? "Me" : this.connectToUser.firstName,
                lastName: (entry.fromUserID == this.myID) ? "" : this.connectToUser.lastName,
                text: entry.body,
                date: entry.timestamp,
                image: entry.image ? entry.image : null,
                seen: entry.hasBeenRead,
                messageID: entry.messageID,
            });
        }

        let element = this.$refs.contentBody as HTMLElement;
        let maxValOld = element.scrollHeight - element.clientHeight;
        let lastVal = element.scrollTop;

        setTimeout(() => {
            // scroll to bottom
            let maxValNew = element.scrollHeight - element.clientHeight;
            
            element.scrollTop = lastVal + (maxValNew - maxValOld);
        },50);
    }

    currentText = "";
    checkInput(e){
        let code = e.keyCode;
        if(code == 13){
            // ENTER
            if(!e.shiftKey){
                e.preventDefault();
                this.send();
            }
        }
    }
    updateText(newText){
        this.currentText = newText;
        frontendClient.wsClient.launchRequest("typing",{
            targetUserID: this.connectToUser.userID,
        });
    }
    async send() {
        if(this.currentText=="" && this.curImageFile == null) return;
        let curMsg = this.currentText.trim();
        let curImg = this.curImageFile;
        
        this.removeImage();

        let inputComp = (this.$refs.input as multiLineEdit);
        inputComp.clear();

        this.curImageFile = null;

        let chatItem = {
            userID: this.myID,
            fullName: "Me",
            firstName: "Me",
            lastName: "",
            text: curMsg,
            date: Date.now(),
            image: curImg ? "data:image/png;base64," + btoa(curImg) : null,
            seen: false,
            messageID: null,
        };
        this.chatResults.items.push(chatItem);

        // scroll to bottom
        let element = this.$refs.contentBody as HTMLElement;
        inputComp.clear();
        element.scrollTop = element.scrollHeight - element.clientHeight;

        setTimeout(() => {
            let element = this.$refs.contentBody as HTMLElement;
            inputComp.clear();
            element.scrollTop = element.scrollHeight - element.clientHeight;
        },0);
        try {
            let res = await frontendClient.postEx("messages/send",{
                toUserID: this.connectToUser.userID,
                body: curMsg,
                image: curImg,
            })

            chatItem.messageID = res.id;
        }
        catch(e) {
            frontendClient.giveError("Message failed to send");
        }
    }

    isTyping = false;

    sleep(t: number) {
        return new Promise((res) => {
            setTimeout(res,t);
        });
    }

    msgCb: any;
    typingCb: any;
    lastTyped: Date;
    mounted(){
       this.$emit('scope','home');

        if(this.connectToUser) {
           this.updateBaseHistory(null,null).then(async () => {
                let element = this.$refs.contentBody as HTMLElement;
                let ctx = 0;
                while((element.scrollHeight - element.clientHeight) <= 0) {
                    if(!this.hasHistory) {break;}
                    await this.sleep(100);
                    await this.updatePastHistory();
                }

                setTimeout(() => {
                    // scroll to bottom
                    let element = this.$refs.contentBody as HTMLElement;
                    element.scrollTop = element.scrollHeight - element.clientHeight;
                },50);
           });
        }

        this.msgCb = (entry) => {
            if(entry.fromUserID === this.connectToUser.userID) {                
                this.chatResults.items.push({
                    userID: entry.fromUserID,
                    fullName: this.connectedToName,
                    lastName: this.connectToUser.lastName,
                    firstName: this.connectToUser.firstName,
                    text: entry.body,
                    date: entry.timestamp,
                    image: entry.image ? entry.image : null,
                    seen: entry.hasBeenRead,
                    messageID: entry.messageID,
                })

                setTimeout(() => {
                    // scroll to bottom
                    let element = this.$refs.contentBody as HTMLElement;
                    element.scrollTop = element.scrollHeight - element.clientHeight;
                },50);

                if(typeCooldown) {
                    clearTimeout(typeCooldown);
                    typeCooldown = null;
                }
                this.isTyping = false;
            }
        };
        frontendClient.wsClient.on("newmessage",this.msgCb)

        let typeCooldown;
        this.typingCb = (data) => {
            if(data.fromUserID !== this.connectToUser.userID) {return;}
            
            this.isTyping = true;

            if(typeCooldown) {
                clearTimeout(typeCooldown);
            }

            typeCooldown = setTimeout(() => {
                typeCooldown = null;
                this.isTyping = false;
            },2500);

            setTimeout(() => {
                // scroll to bottom
                let element = this.$refs.contentBody as HTMLElement;
                element.scrollTop = element.scrollHeight - element.clientHeight;
            },50);
        }
        frontendClient.wsClient.on("typing",this.typingCb)
    }

    beforeDestroy() {
        frontendClient.wsClient.removeListener("newmessage",this.msgCb)
        frontendClient.wsClient.removeListener("typing",this.typingCb)
    }

}
